import React, { useState } from "react";
import { Offcanvas, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import FormDataPage from "./RequestDemo";

const Sidebar = ({ show, handleShow, handleClose, setShow }) => {
  const [form, setForm] = useState(false);

  const handleRequestDemoClick = (e) => {
    e.preventDefault();
    handleClose(); // Close the sidebar
    setForm(true); // Open the modal
  };

  // Function to handle navigation and close the sidebar
  const handleNavLinkClick = () => {
    handleClose(); // Close the sidebar
  };

  return (
    <>
      <Modal
        show={form}
        keyboard={false}
        backdrop="static"
        onHide={() => {
          setForm(false);
        }}
        centered
        className="modelDsider"
      >
        <Modal.Header closeButton>
          <Modal.Title>Please fill the form</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormDataPage setForm={setForm} />
        </Modal.Body>
      </Modal>
      <div>
        <Offcanvas
          show={show}
          onHide={handleClose}
          placement="end"
          className="side__bar"
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <section>
              <div className="p-0">
                <div className="side_navBar unClick">
                  <NavLink to="/" onClick={handleNavLinkClick}>Home</NavLink>
                  <NavLink to="/industries" onClick={handleNavLinkClick}>Industries</NavLink>
                  <NavLink to="/technology" onClick={handleNavLinkClick}>Technology</NavLink>
                  <NavLink to="/upstream" onClick={handleNavLinkClick}>Upstream</NavLink>
                  <NavLink to="/midstream" onClick={handleNavLinkClick}>Midstream</NavLink>
                  <NavLink to="/products" end onClick={(e) => e.preventDefault()} aria-disabled="true" style={{ opacity: 0.4, pointerEvents: "none" }}>CleanTech</NavLink>
                  {/* <NavLink to="/team" onClick={handleNavLinkClick}>Our Team</NavLink> */}
                  <NavLink to="/news" onClick={handleNavLinkClick}>News</NavLink>
                  <NavLink to="/blogs" onClick={handleNavLinkClick}>Blogs</NavLink>
                  <NavLink to="/contact" onClick={handleNavLinkClick}>Contact Us</NavLink>
                  <NavLink to="/careers" onClick={handleNavLinkClick}>Careers</NavLink>
                  <NavLink
                    to="/link"
                    id="GetInTouchBtnMobile"
                    className="z-btn-mobileview z-btn-3-mobileview"
                    onClick={handleRequestDemoClick}
                  >
                    Request Demo
                  </NavLink>
                </div>
              </div>
            </section>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
};

export default Sidebar;